import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('loading-animate', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 128 128",
    width: props.size,
    height: props.size
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.063875,2.68525 C30.1685,2.68525 2.685375,30.167875 2.685375,64.063875 C2.685375,97.9605 30.167375,125.442625 64.063875,125.442625 C67.383125,125.442625 70.073875,122.75175 70.073875,119.432625 C70.073875,116.113375 67.383125,113.422625 64.063875,113.422625 C36.80575,113.422625 14.70525,91.322125 14.70525,64.063875 C14.70525,36.806375 36.806875,14.70525 64.064,14.70525 C91.322125,14.70525 113.422625,36.80575 113.422625,64.064 C113.422625,67.383125 116.113375,70.074 119.432625,70.074 C122.75175,70.074 125.442625,67.383125 125.442625,64.064 C125.442625,30.167375 97.9605,2.68525 64.063875,2.68525 L64.063875,2.68525 Z",
    fillRule: "nonzero",
    fill: props.colors[0]
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeType: "XML",
    attributeName: "transform",
    begin: "0s",
    dur: "1s",
    type: "rotate",
    from: "0 64 64",
    to: "360 64 64",
    repeatCount: "indefinite"
  }))));
});